import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Params, QueryParamsHandling } from '@angular/router';
import { DsButtonIntent, DsButtonVariants } from '@levelaccess/design-system';
import { Observable, Subscription } from 'rxjs';
import { BaseCellComponent, ICellConfig } from '../base-cell/base-cell.component';

export interface IDSButtonLinkCellConfig extends ICellConfig {
  variant: DsButtonVariants;
  intent?: DsButtonIntent;
  isDisabled$?: Observable<boolean>;
  ariaLabel?: string;
  clickListener?: Function;
}

@Component({
  selector: 'table-cell-ds-button-link',
  styleUrls: ['../base-cell/base-cell.component.scss'],
  standalone: false,
  templateUrl: './ds-button-link-cell.component.html',
})
export class DSButtonLinkCellComponent extends BaseCellComponent implements OnInit, OnDestroy {
  @Input() public config: IDSButtonLinkCellConfig;
  @ViewChild('ref', { read: ElementRef })
  public override element: ElementRef<HTMLElement>;
  public isDisabled: boolean = false;
  public routerLink: string | any[] | null = null;
  public queryParams: Params = {};
  public fragment: string | null = null;
  public queryParamsHandling: QueryParamsHandling = '';
  public state: { [k: string]: any } = null;
  public href: string | null = null;
  public target: string | null = null;
  public rel: string | null = null;
  private isDisabledSubscription: Subscription | null = null;

  public ngOnInit(): void {
    const attributes: { [attribute: string]: any } = this.config?.attributes || {};
    this.routerLink = attributes['routerLink'] || null;
    this.queryParams = attributes['queryParams'] || {};
    this.fragment = attributes['fragment'] || null;
    this.queryParamsHandling = attributes['queryParamsHandling'] || '';
    this.state = attributes['state'] || null;
    this.href = attributes['href'] || null;
    this.target = attributes['target'] || null;
    this.rel = attributes['rel'] || null;

    this.isDisabledSubscription =
      this.config?.isDisabled$?.subscribe((value: boolean) => {
        this.isDisabled = value === true;
      }) || null;
  }

  public ngOnDestroy(): void {
    this.isDisabledSubscription?.unsubscribe();
    this.isDisabledSubscription = null;
  }

  public onClick(event: MouseEvent, isDisabled: boolean): void {
    event?.stopPropagation();
    if (isDisabled) {
      event?.preventDefault();
      return;
    }
    this.config?.clickListener?.();
  }
}
